import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import zh from './zh.json';

// Phase 1 scope: foundation + Login only.
// Defensive defaults so missing keys NEVER crash a page.

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
    },
    fallbackLng: 'en',          // missing zh key → English
    supportedLngs: ['en', 'zh'],
    interpolation: { escapeValue: false }, // React handles escaping

    // Detection: localStorage first, then browser, default English
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'pp_map_lang',
    },

    // Map browser locales to our 2 languages
    load: 'languageOnly',  // 'zh-CN' → 'zh', 'en-US' → 'en'

    // Defensive: missing keys show as visible placeholder, never undefined
    parseMissingKeyHandler: (key) => `[${key}]`,
    saveMissing: false,
    returnEmptyString: false,
    returnNull: false,

    // Don't suspend — we control loading via SafeBoundary
    react: { useSuspense: false },
  });

export default i18n;
